import React, { useState } from 'react'
import './sectionsix.css';
import axios from 'axios';

export default function SectionSix() {
  

const [sent, setSent] =useState(false);
const [name, setName] = useState('');
const [email, setEmail] = useState('');
const [message, setMessage] = useState('');


const handleSend = async (e) => {
    e.preventDefault();
    setSent(true);
    try{
        await axios.post("http://https://us-central1-chariscodingclub-a6025.cloudfunctions.net/app/send_mail", {
        name, email, message
        })
    }
    catch(error){
        console.log(error)
    }

}
    return (
        <div className='section5__main'>
         
            <div className="section__bottom">
                
                {!sent ? 
                <form className="form" method="post">
                 
                    <div className="form__right">
                            <h3 className='head__three'>
                            Don’t hesitate to contact us, leave us a message.
                            </h3>
                        <div className="form__body">
                           

                            <input type="text" name="" value={name} onChange = {
                                (e) => setName(e.target.value)
                            } id=""  placeholder='Full Name'/>
                           
                        </div>
                        <div className="form__body">
                           

                            <input type="text" name="" value={email} onChange = {
                                (e) => setEmail(e.target.value)
                            } id="" placeholder='Email Address' col='50'/>
                           
                        </div>
                        <div className="form__body">
                           

                            <textarea value={message} onChange = {
                                (e) => setMessage(e.target.value)
                            } id="" placeholder='Message'/>
                           
                        </div>
                        <button className='pri__btn' type='submit' onClick={handleSend}> Send Message </button>
                    </div>
                </form>
                : 
                <h1>Email Sent </h1>
                        }

            </div>
        </div>
    )
}



